import * as React from 'react';
import FormView from 'components/FormView';
import { withRouter } from 'react-router';
import { IProductLinks } from '../interfaces';

class ProductLinks extends React.PureComponent<IProductLinks> {

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    if (path) {
      switch (path) {
        case '/supplier-product-enquiry/product-links':
          onInitialLoad('ProductLinks');
          break;
        default:
          onInitialLoad('ProductLinks');
      }
    }
  }

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedTab, selectedForm, operationMode, isLoading } = this.props;

    return (selectedForm &&
      <React.Fragment>
        <FormView
          isLoading={isLoading}
          formName={selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          browseLookUpComponent={selectedTab}
          schema={selectedForm}
          includeTabsHeight={false}
          operationMode={operationMode}
          enableReinitialize={true}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(ProductLinks);
